<template>
  <main class="maintenance-page">
    <img
      class="maintenance-page--logo"
      alt="Wrios"
      src="@/assets/logo-wrios.svg"
    />

    <section class="maintenance-page--card" aria-labelledby="maintenance-title">
      <h1 id="maintenance-title" class="maintenance-page--title">
        WRIOS is down for maintenance
      </h1>
      <p>We're restringing and retuning. We'll be back up soon.</p>

      <p class="maintenance-page--thanks">Thanks for your patience.</p>
    </section>
  </main>
</template>

<script>
export default {
  name: 'Maintenance',

  beforeCreate() {
    // Cancels the mobile navbar's body padding (layout/_nav.scss); there is no navbar here.
    document.body.classList.add('is-maintenance')
  },

  mounted() {
    this.previousTitle = document.title
    document.title = 'Down for maintenance · Wrios'
  },

  beforeDestroy() {
    document.body.classList.remove('is-maintenance')
    document.title = this.previousTitle
  }
}
</script>
